import { render, staticRenderFns } from "./userSelector.vue?vue&type=template&id=4027021c&scoped=true"
import script from "./userSelector.vue?vue&type=script&lang=js"
export * from "./userSelector.vue?vue&type=script&lang=js"
import style0 from "./userSelector.vue?vue&type=style&index=0&id=4027021c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4027021c",
  null
  
)

export default component.exports